/* Hosted model picker — populates #modelSelect from the operator's catalog
   (GET /api/models) and sends the choice with each run frame (main.js reads
   selectedModel()). Local/desktop mode runs whatever backend the operator
   configured, so the picker is hidden there — a visible select would imply a
   choice that doesn't exist. Models the user's plan doesn't include render
   disabled with a "· Pro" suffix; the run route re-enforces both the catalog
   and the tier gate server-side. */

import { api } from './api.js';
import { getAuthMode } from './auth.js';

const LS_KEY = 'cpq.hostedModel';

export function selectedModel() {
  const el = document.getElementById('modelSelect');
  if (!el || el.hidden || !el.value) return null;
  return el.value;
}

// Pure DOM builder: render the catalog into the select and pick the initial
// value (saved choice if still offered+allowed, else the catalog default,
// else the first allowed entry). Split out so tests can drive it with
// synthetic data — no auth or fetch involved.
export function populateModelPicker(el, data, saved) {
  const models = (data && data.models) || [];
  if (!models.length) { el.hidden = true; return; }
  el.innerHTML = '';
  for (const m of models) {
    const opt = document.createElement('option');
    opt.value = m.id;
    opt.textContent = m.allowed ? m.id : `${m.id} · Pro`;
    opt.disabled = !m.allowed;
    el.appendChild(opt);
  }
  const savedOk = models.some((m) => m.id === saved && m.allowed);
  el.value = savedOk ? saved : (data.default || models[0].id);
  const cur = el.options[el.selectedIndex];
  if (!cur || cur.disabled) {
    const firstAllowed = models.find((m) => m.allowed);
    if (firstAllowed) el.value = firstAllowed.id;
  }
  el.hidden = false;
}

export async function initModelPicker() {
  const el = document.getElementById('modelSelect');
  if (!el) return;
  if (getAuthMode() !== 'hosted') { el.hidden = true; return; }
  let data;
  try {
    data = await api.hostedModels();
  } catch {
    el.hidden = true;   // catalog route unavailable — run frames just omit `model`
    return;
  }
  populateModelPicker(el, data, localStorage.getItem(LS_KEY));
  el.addEventListener('change', () => localStorage.setItem(LS_KEY, el.value));
}

// Test hook (pattern: window.__cpqWsSend in main.js) — lets the E2E drive the
// pure populate logic with synthetic catalogs without hosted auth.
window.__cpqPopulateModelPicker = populateModelPicker;
